import { toast } from "react-toastify";
import { apiSlice } from "../api/apiSlice";

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (status) => ({
        url: `user?status=${status}`,
      }),
      providesTags: ["Users"],
    }),

    getUser: builder.query({
      query: (id) => ({
        url: `user/${id}`,
      }),
      providesTags: ["User"],
    }),

    addUser: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/register`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Registration completed successfully");
        } catch (err) {
          toast.error("An error occurred while registration");
        }
      },
      invalidatesTags: ["Users"],
    }),

    updateUser: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("User updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating user");
        }
      },
      invalidatesTags: ["Users", "User"],
    }),

    deleteUser: builder.mutation({
      query: (id) => ({
        url: `user/${id}`,
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: false,
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Deleted status successful");
        } catch (err) {
          toast.error("An error occurred while deleting the user");
        }
      },
      invalidatesTags: ["Users", "User"],
    }),

    login: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user/login`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          localStorage.setItem("access-token", data?.token);
          localStorage.setItem("role", data?.role);
          localStorage.setItem("user", data?.userName);
          localStorage.setItem("id", data?.id);
          localStorage.setItem("isLogged", true);
          toast.success("User logged in successfully");
          window.location.href = "/admin/dashboard";
        } catch (err) {
          toast.error("An error occurred while login");
        }
      },
      invalidatesTags: ["Users"],
    }),
  }),
});

export const {
  useGetUserQuery,
  useGetUsersQuery,
  useAddUserMutation,
  useUpdateUserMutation,
  useLoginMutation,
  useDeleteUserMutation,
} = userApi;
